<template>
  <div class="contenedor-barras-apiladas"
  v-bind:id="barras_apiladas_id"
  :class="{'es-un-estado':esUnEstado}"
  >
    <div class="barras-header">
      <a class="titulo-proyecto" v-if="enlace_proyecto" :href="enlace_proyecto">
        {{titulo_proyecto}}
      </a>
      <p class="titulo-proyecto" v-if="!enlace_proyecto && titulo_proyecto">
        {{titulo_proyecto}}
      </p>
      <h3 class="titulo-visualizacion" v-if="titulo">{{titulo}}</h3>
      <p class="instruccional" v-if="instruccional">{{instruccional}}</p>
    </div>
    <div class="barras-body">
      <button class="button-volver"
      v-bind:style="{visibility: zoom_activo}"
      @click="resetearZoom">
      <span class="icono-sm icono-atras"></span>
    </button>
    <div class="contenedor-svg" ref="contenedor_svg">
      <svg class="svg-barras-apiladas">
      <defs></defs>
      <g class="gupo-contenedor-de-barras"></g>
      <g class="grupo-contenedor-tooltip">
        <foreignObject >
          <div class="tooltip-contenido">
            <div class="contenedor-boton-cerrar">
              <span>{{titulo_tooltip}}</span>
              <button class="boton-cerrar-tooltip">
                <img src="@/assets/img/cerrar.svg" alt="Cerrar Tooltip">
              </button>
            </div>
            <p class="tooltip-variable">Nombre de variable 2 </p>
            <p class="tooltip-cifra">120 | <b> 29.3%<b></b></b></p>
          </div>
        </foreignObject>
      </g>
      </svg>
    </div>
    </div>

    <div class="barras-footer">
      <div id="leyenda-barras-apiladas">
      <p class="titulo-leyenda">{{titulo_leyenda}}</p>
      <div class="label-1" v-for="(variable,i) in variables" :key="variable.id">
        <CheckboxColor :color="variable.color" v-model="lista_filtros_activos[i]" >
        <span class="categoria-texto">{{variable.nombre}}</span>
        </CheckboxColor>
      </div>

    </div>
    <div v-if="notas" class="barras-apiladas-notas" :class="{open:notas_open}">
      <div class="content">
        <div class="contenedor-notas" v-if="texto_notas">
          <p><strong>Notas</strong></p>
          <p>
            {{texto_notas}}
          </p>
        </div>
        <div class="contenedor-fuente" v-if="texto_fuente">
          <p><strong>Fuente: </strong>{{texto_fuente}}</p>
        </div>
      </div>
      <button aria-hidden="true" class="summary" @click="notas_open=!notas_open" type="button">
        {{notas_open ? "MENOS INFORMACIÓN": "MÁS INFORMACIÓN"}}
      </button>
    </div>
    </div>

  </div>
</template>

<script>
import * as d3 from 'd3';
import CheckboxColor from "./CheckboxColor.vue"

export default {
  name: 'DaiBarrasAgrupadas',
  components:{
    CheckboxColor
  },
  props: {
    barras_apiladas_id: {
      type: String,
      default: () => 'barras',
    },
    datos: {
      type: Array,
      default: () => [{nombre:'Nombre de variable 2 ', cantidad_1:120,cantidad_2:30}],
    },
    titulo: String,
    instruccional: String,
    titulo_leyenda: String,
    enlace_proyecto: String,
    titulo_proyecto: String,
    texto_fuente: String,
    texto_notas: String,
    link_descarga_csv: String,
    nombre_variables:{
      type: Object,
      default:function(){
        return { 'nombre':'nombre' }
      }
    },
    columnas_descargables: {
      type: Array,
      default: () => ['nombre', 'cantidad_1', 'cantidad_2'],
    },
    titulo_tooltip: {
      type: String,
      default: '',
    },
    ancho_tooltip: {
      type: Number,
      default: 180,
    },
    alto_vis: {
      type: Number,
      default: 500,
    },
    ancho_vis: {
      type: Number,
      default: 500,
    },
    notas: {
      type: String
    },
    margen: {
      type: Object,
      default: () => ({
        arriba: 10,
        abajo: 30,
        izquierda: 60,
        derecha: 20,
      }),
    },
    variables: {
      type: Array,
      default:function(){
        return ['nombre','cantidad_1','cantidad_2']
      }
    },
    soloUnGrupo:{
      default:false
    }
  },
  watch: {
    variables(nuevoval)  {
      this.variables = nuevoval;
      this.barras_apiladas
        .style('fill', (d, i) => this.variables[i].color);
    },
    datos(nv, ov) {
      this.datos = nv;
      this.configurandoDimensionesParaSVG(this.soloUnGrupo)
      this.configurandoDimensionesParaBarras();
      if (nv.length > ov.length) {
        // Actualizamos paths
        this.barras_apiladas = this.grupo_contenedor
          .selectAll('g.grupos-barras')
          .data(this.data_apilada);
        this.barras_apiladas = this.barras_apiladas.enter()
          .append('g')
          .style('cursor', 'pointer')
          .merge(this.barras_apiladas);
        this.barras_apiladas.exit().remove();
      } else {
        this.barras_apiladas.data(this.data_apilada)
          .exit()
          .remove();
      }
      this.barras_apiladas
        .attr('class', (d) => `${d.key} grupos-barras`)
        .style('fill', (d, i) => this.variables[i].color);

      this.barras_individuales.remove();
      this.barras_individuales = this.barras_apiladas
        .selectAll('rect')
        .data((d) => d)
        .enter()
        .append('rect');
      this.reestablecerVista();
      this.actualizandoBarras();
    },
    lista_filtros_activos(lista) {
      lista.forEach((checkbox,i)=>{
        const gElement = document.querySelector(`.${this.variables[i].id}.grupos-barras`)
        gElement.style.display= checkbox ? '' : 'none';
      })
    },
    soloUnGrupo:function(solo1grupo){
      if(solo1grupo){
        this.configurandoDimensionesParaSVG(solo1grupo)

        this.configurandoDimensionesParaBarras();
        this.actualizandoBarras()
      }
    }
  },
  data: function() {
    return {
      notas_open: false,
      orden_inicial: true,
      zoom_activo: 'hidden',
      width: 200,
      height: 0,
      lista_filtros_activos:[],
      timer_scroll: 0,
      scroll_left : 0,
      modo_tooltip : "hover"
    }
  },
  mounted() {
    this.svg = d3.select(`div#${this.barras_apiladas_id} svg.svg-barras-apiladas`);
    this.grupo_contenedor = this.svg.select('g.gupo-contenedor-de-barras');
    this.grupo_contenedor_tooltip = this.svg.select('g.grupo-contenedor-tooltip');
    this.eje_x = this.grupo_contenedor
      .append('g')
      .attr('class', 'eje-x');
    this.eje_y = this.grupo_contenedor
      .append('g')
      .attr('class', 'eje-y')
    this.configurandoDimensionesParaSVG(this.soloUnGrupo);
    this.configurandoDimensionesParaBarras();
    this.creandoBarras();
    this.actualizandoBarras();

    this.tooltip = this.grupo_contenedor_tooltip
      .select('foreignObject');
    window.addEventListener('resize', this.reescalandoPantalla);

    this.lista_filtros_activos = this.variables.map(item=>true);

    this.eje_y
        .attr('transform', `translate(0,0)`);
    this.$refs.contenedor_svg.addEventListener("scroll",(e)=>{
      
      this.scroll_left =e.target.scrollLeft
      clearTimeout( this.timer_scroll)
      this.timer_scroll = setTimeout(()=>{
        this.eje_y.transition()
        .duration(200)
        .attr('transform', `translate(${e.target.scrollLeft},0)`);
      },200)
      
    })
  },
  methods: {
    actualizarGraficaZoom(evento){
      this.zoom_activo = 'visible';
      this.tooltip.style('visibility', 'hidden');

      this.escalaX.range([
        this.margen.izquierda,
        this.width - this.margen.derecha,
      ].map((d) => evento.transform.applyX(d)));
      this.escalaSub.range([0, this.escalaX.bandwidth()])

      this.eje_x.call(d3.axisBottom(this.escalaX));
      this.eje_x.select('path.domain')
        .attr('d', function(){ d3.select(this).attr('d').replace('M-6', 'M 0').replace('H-6', 'H0')});

      this.barras_individuales
        .attr('x', (d) => this.escalaX(d.data[this.nombre_variables.nombre]) + this.escalaSub(d.data.key))
        .attr('width', this.escalaSub.bandwidth);
    },
    resetearZoom() {
      this.svg.call(
        this.zoom.transform,
        d3.zoomIdentity,
      );
      this.configurandoDimensionesParaSVG(this.soloUnGrupo);
      this.configurandoDimensionesParaBarras();
      this.actualizandoBarras();

      this.eje_x.call(d3.axisBottom(this.escalaX));
      this.eje_x.select('path.domain')
        .attr('d', function(){ d3.select(this).attr('d').replace('M-6', 'M 0').replace('H-6', 'H0')});
      this.zoom_activo = 'hidden';
    },
    configurandoDimensionesParaSVG(ungrupo = false) {
      
      //this.width = document.getElementById(this.barras_apiladas_id).clientWidth
      //  - this.margen.izquierda - this.margen.derecha;
      //this.width = this.datos.length>1 ? this.width : (windowWidth>=769 ? this.width - 300: this.width);
      const es_mobile = window.innerWidth<=769;
      this.margen.izquierda = es_mobile ? 40 :60
      this.margen.derecha = es_mobile ? 10 :20
      
      const ancho =ungrupo ? (es_mobile? this.$el.clientWidth: this.$el.clientWidth - 300) : this.ancho_vis
      this.width = ancho - this.margen.izquierda - this.margen.derecha;
      this.height = this.alto_vis - this.margen.arriba - this.margen.abajo;
      this.svg.attr('width', this.width + this.margen.izquierda + this.margen.derecha)
        .attr('height', this.height + this.margen.arriba + this.margen.abajo);

      this.grupo_contenedor
        .attr('transform', `translate(${this.margen.izquierda},${this.margen.arriba})`);
      this.grupo_contenedor_tooltip
        .attr('transform', `translate(${this.margen.izquierda},${this.margen.arriba})`);
      const extent = [[this.margen.izquierda, this.margen.arriba], [this.width, this.height]];



      //this.zoom = d3.zoom()
      //  .scaleExtent([1, 8])
      //  .translateExtent(extent)
      //  .extent(extent)
      //  .on('zoom', (evento)=>{this.actualizarGraficaZoom(evento)});
      //this.svg.call(this.zoom);




    },
    configurandoDimensionesParaBarras() {
      this.data_apilada = d3.stack()
        .keys(this.variables.map((d) => d.id))(this.datos);
      for (let i = this.variables.length -1 ; i >= 0; i -= 1) {
        this.data_apilada[i].forEach((dd) => {
          dd.data = Object.assign({ }, dd.data, { key: this.data_apilada[i].key });
        });
      }
      this.escalaY = d3.scalePow().exponent(.5) //d3.scaleLinear()
        .domain([0, d3.max(this.datos.map((d) => d3.max(this.variables.map((dd) => d[dd.id]))))])
        .range([ this.height ,0]);

      this.escalaX = d3.scaleBand()
        .domain(this.datos.map((d) => d[this.nombre_variables.nombre]))
        .range([0, this.width])
        .padding(0.1); //padding entre grupos de barras
        //console.log(this.height,this.escalaX.bandwidth())
      this.escalaSub = d3.scaleBand()
        .domain(this.variables.map((d) => d.id))
        .range([0, this.escalaX.bandwidth()])
        .padding(0.02);
        //console.log(this.escalaSub.bandwidth())
      this.eje_y.transition().duration(100).call(
        d3.axisLeft(this.escalaY)
        //.tickValues([0,500,1000,1500,2500])
        .ticks(4)
      )
        //
      this.eje_x.call(d3.axisBottom(this.escalaX))
      .attr('transform', `translate(0,${this.height})`);
      this.eje_x.select('path.domain')
        .attr('d', function() { d3.select(this).attr('d').replace('M-6', 'M 0').replace('H-6', 'H0')});
      
      this.eje_y
        .attr('transform', `translate(0,0)`);
    },
    creandoBarras(){
      //console.log(this.data_apilada);
      this.barras_apiladas = this.grupo_contenedor
        .selectAll('grects')
        .data(this.data_apilada)
        .enter()
        .append('g')
        .attr('class', (d) => `${d.key} grupos-barras`)
        .style('fill', (d, i) => this.variables[i].color)
        .on('mouseover', (evento, datum) => this.mouseOverBarras(evento, datum))
        .on('mouseout', this.mouseOutBarras);
      this.barras_individuales = this.barras_apiladas
        .selectAll('rect')
        .data((d) => d)
        .enter()
        .append('rect')
        
    },
    mouseOverBarras(evento, datum) {
      this.grupo_contenedor.selectAll('g.grupos-barras')
        .interrupt()
        .transition()
        .duration(250)
        .style('opacity', 0.25);
      this.grupo_contenedor.selectAll(`g.grupos-barras.${datum.key}`)
        .interrupt()
        .transition()
        .duration(250)
        .style('opacity', 1);
    },
    mouseOutBarras() {
      this.grupo_contenedor.selectAll('g.grupos-barras')
        .interrupt()
        .transition()
        .duration(250)
        .style('opacity', 1);
    },
    actualizandoBarras() {
      //console.log(this.escalaY,this.nombre_variables.nombre)
      this.barras_individuales
        .attr('y', (d) =>  this.escalaY(d[1] - d[0]) )
        .attr('x', (d) => {
          //console.log(d.data, this.escalaSub(d.data.key))
          return this.escalaX(d.data[this.nombre_variables.nombre]) + this.escalaSub(d.data.key)
          })
        .attr('width', this.escalaSub.bandwidth())
        .attr('height', (d) => {
          return this.escalaY(0) - this.escalaY( d[1] - d[0]);
          })
        .on('click', (evento, datum) => {
          this.modo_tooltip="click"
          this.mostrarTooltip(evento, datum)
        })
        .on("mouseover",(evento, datum)=> {
          if(this.modo_tooltip!=="click"){
            this.mostrarTooltip(evento, datum) 
          }
          
        })
        .on("mouseout", ()=>{
          if(this.modo_tooltip=="hover"){
            this.reestablecerVista()
          }
        })
      this.eje_y.selectAll('line')
        .attr('x1', this.width)
        .style('stroke-dasharray', '3 2')
        .style('stroke', '#707070');
      this.eje_y.select('path')
        .style('opacity', 0);
      this.eje_x.selectAll('line').remove();



      //
      //
    },
    reescalandoPantalla() {
      this.configurandoDimensionesParaSVG(this.soloUnGrupo);
      this.configurandoDimensionesParaBarras();
      this.actualizandoBarras();
    },
    mostrarTooltip(evento, datum) {
      //console.log(evento.target.getAttribute("x"),evento.target.getAttribute("x")+10)
      
      let xx = Number(evento.target.getAttribute("x"))+10
      xx = (xx + 193 ) > this.ancho_vis ? this.ancho_vis - 193 - this.margen.derecha -this.margen.izquierda :xx
      
      let yy = Number(evento.target.getAttribute("y"))
      yy = (yy - 100)  > this.alto_vis ? this.alto_vis - 100 : yy - 100
      yy = yy<0 ? 0 :yy
      //console.log(xx,yy)
      //this.tooltip.style('visibility', 'visible');
      this.tooltip.style('display', '');
      
      this.tooltip
        .attr("x",xx)
        .attr('width', this.ancho_tooltip)
        .attr('height', 30);
      const contenidoTooltip = this.tooltip.select('div.tooltip-contenido')
        .style('background', 'rgba(0, 0, 0,.8)')
        .style('min-width', this.ancho_tooltip)
        .style('border-radius', '8px')
        .style('width', `${this.ancho_tooltip}px`)
        .attr('height', 70)
        .style('padding', '0 3px 0 10px');
      this.svg.select('button.boton-cerrar-tooltip')
        .on('click', this.reestablecerVista);
      contenidoTooltip
        .select('p.tooltip-variable')
        .text(datum.data.nombre)
        .style('margin', '0')
        .style('padding', '0');
      contenidoTooltip
        .select('p.tooltip-cifra')
        .html(`${this.variables.filter((d) => d.id === datum.data.key)[0].nombre} | <b>${datum.data[this.variables.filter((d) => d.id === datum.data.key)[0].id].toLocaleString('en')}<b>`)
        .style('margin', '0')
        .style('padding', '0 0 5px 0');
      this.tooltip
        .attr('height', contenidoTooltip.style('height'))
        .style('height', contenidoTooltip.style('height'))
        .attr('width', parseInt(contenidoTooltip.style('width'), 10) + 13)
        .attr('y', yy);
    },
    reestablecerVista() {
      this.modo_tooltip = "hover"
      //this.tooltip.style('visibility', 'hidden');
      this.tooltip.style('display', 'none');
    },
  },
  computed: {
    esUnEstado() {
      return this.datos.length == 1;
    }
  },
};
/* eslint-enable */
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  $border-radius-tarjeta: 10px;
  button.button-volver {
    background: #fff;
    color: #000;
    height: 40px;
    width: 40px;
    float: right;
    &:hover,
    &:focus {
      background: #000;
      color: #fff;
    }
  }
  .titulo-proyecto {
    padding: 10px 10px 0px 10px;
    text-align: right;
    font-size: 14px;
    display: inherit;
  }
  .titulo-visualizacion {
    font-size: 16px;
    padding: 10px;
    margin: 0;
  }
  p.instruccional{
    font-size: 12px;
    padding: 0 10px;
    margin: 5px 0;
  }
  div.contenedor-barras-apiladas {
    font-family: "Montserrat";
    width: 100%;
    // border: solid black 1px;
    // border-radius: $border-radius-tarjeta;
    @media (min-width: map-get($media-queries-limit, "mobile")) {
      &.es-un-estado{
        display: grid;
        grid-template-areas: "header body"
                            "footer body";
        grid-template-columns: 300px 1fr;
        grid-template-rows: auto 1fr;
        .barras-header{
          grid-area: header;
          border-right: 1px solid black;
        }
        .barras-body{
          grid-area: body;
        }
        .barras-footer{
          grid-area: footer;
          border-right: 1px solid black;
          border-top: 1px solid black;
          div#leyenda-barras-apiladas{
            box-shadow: none;
            >div{
              width: 50%;
              flex: 0 0 50%;
            }
          }
        }
      }
    }

  }
  div#leyenda-barras-apiladas{
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -ms-flex-wrap: wrap;
    flex-wrap: wrap;
    border-radius: $border-radius-tarjeta;
    box-shadow: 0px -5px 5px -1px rgb(221, 221, 221);
    margin-bottom:10px;
    justify-content: center;
    p.titulo-leyenda{
      width: 100%;
      margin-bottom: 5px;
      text-align: center;
      font-size: 12px;
      font-weight: 700;
    }
    div{
      margin-top: 10px;
      width: 50%;
      -ms-flex: 0 0 50%;
      flex: 0 0 50%;
      @media (min-width: map-get($media-queries-limit, "mobile")) {
        width: 16%;
        -ms-flex: 0 0 16%;
        flex: 0 0 16%;
      }
      max-width: calc(50% - 20px);
      padding: 0px 10px;
      display: flex;
      span.categoria-color{
        width: 25px;
        height: 25px;
        min-width: 25px;
        display: inline-block;
        border-radius: 50%;
        position: relative;
      }
      span.categoria-texto{
        display: inline-block;
        position: relative;
        padding-left: 5px;
        font-size: 10px;
        top: 50%;
        transform: translateY(-50%);
        margin-bottom: auto;
      }
      &.active{
        color:#000;
      }
      &.inactive{
        color:gray;
        span.categoria-color{
          background:#dbdbdb!important;
        }
      }
    }
  }

  .barras-apiladas-notas {
    color: #222;
    .summary {
      height: 30px;
      background:#000;
      color: #fff;
      text-align: center;
      font-size:12px;
      font-weight: 500;
      padding: 4px;
      width: 100%;
      border: solid 1px #000;
      border-radius:0 0 $border-radius-tarjeta $border-radius-tarjeta;
      transition: all .27s ease-in-out;
      &:hover,
      &:focus,
      &:active {
        background-color: #000;
        color: #fff;
      }
    }
    .content {
      max-height: 0;
      overflow: hidden;
      transition: all .33s ease-in-out;
      padding: 0 15px;
      font-size: 12px;
      line-height: 1.3em;
    }
    &.open {
      height: auto;
      .content{
        max-height: 200px;
        padding: 5px 15px;
      }
    }
  }
  .barras-apiladas-notas {
    .content {
      .contenedor-notas{
        border-top: solid 1px #000;
      }
      .contenedor-fuente{
        border-top: solid 1px rgb(192, 192, 192);
      }
      .contenedor-descarga{
        border-top: solid 1px #000;
        display: flex;
        .descargar-datos{
          cursor: pointer;
          margin: 15px auto;
          font-size: 10px;
          color: #fff;
          background: #000;
          border: none;
          padding: 5px 10px;
          border-radius: 3px;
          text-decoration:none;
          img{
            position: relative;
            top:2px;
            margin-left: 5px;
          }
        }
      }
    }
  }

  svg.svg-barras-apiladas:deep(foreignObject) {
    color:#fff;
    font-size: 12px;

  }
  svg.svg-barras-apiladas:deep(div.contenedor-boton-cerrar) {
    height: auto;
    display: flex;
    width: 100%;
    padding-top: 5px;
    justify-content: space-between;
  }

  svg.svg-barras-apiladas:deep(button.boton-cerrar-tooltip) {
    background: none;
    border: none;
    padding: 0 0 0 5px;
    cursor: pointer;
    img {
      width: 15px;
      height: 15px;
    }
    @media (min-width: map-get($media-queries-limit, "mobile")) {
      display: none;
    }
  }

  .contenedor-svg{
    overflow-x: auto;
    width: 100%;
  }

</style>
